import ApplicationController from './application'
import { numbers_only } from '../helpers/helpers'

export default class extends ApplicationController {

  static targets = ['input']

  connect() {
    if (!this.hasInputTarget) return

    const input = this.inputTarget

    input.addEventListener('input', (e) => {
      input.value = numbers_only(input.value)
    })
  }
}
